
<template>
  <b-modal title="New Organization" 
    v-model="showModal"
    @ok.prevent="submit(false)"
    :ok-disabled="sending"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form @submit.prevent>
      <b-row>
        <b-col>
          <b-form-group
            label="Name"
            label-for="new-org-name"
            invalid-feedback="Please enter a name"
            :state="errors.length == 0 ? null : form.name !== ''">
            <b-form-input
              id="new-org-name"
              v-model="form.name"
              required
              maxlength="100"
              :state="errors.length == 0 ? null : form.name !== ''"
              @keyup.enter="submit(false)">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <div style="width: 36px;" >
          <b-spinner v-if="sending" small label="Spinning"/>
          <div v-else>Add</div>
        </div>
      </template>
    </b-form>
    <BaseConfirmationModal
      ref="confirm-organization-modal"
      :title="'Existing Organization'"
      :okText="'Yes'"
      :message="confirmMessage"
      @submit="confirmOrganizationSubmit"
      @cancel="confirmOrganizationCancel"
    ></BaseConfirmationModal>
  </b-modal>
</template>
<script>
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";

export default {
  props: {
    organizations: { type: Array, default: () => [] }
  },
  components: {
    BaseConfirmationModal
  },
  data() {
    return {
      errors: [],
      showModal: false,
      sending: false,
      form: {
        organizationId: this.$helpers.generateUUID(),
        name: "",
      }
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    submit(force) {
      this.errors = [];
      
      if (!this.validateForm()) {
        return;
      }

      //check if existing organization
      if (this.organizationExists()) {
        this.form = {
          ...this.organizations.find(o => o.name === this.form.name)
        };
        if (!force) {
          this.confirmOrganization();
          return;
        }
      }

      this.$emit("add", this.form);
      this.resetForm();
      this.hide();
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    validateForm(){
      const initErrors = this.errors.length;
      let form = this.form;
      form.name = form.name.trim();

      if (form.name === '') {
        this.errors.push({ message: 'Name cannot empty'});
      }

      return initErrors === this.errors.length;
    },
    resetForm() {
      this.errors = [];
      this.form = {
        organizationId: this.$helpers.generateUUID(),
        name: ""
      };
    },
    organizationExists() {
      return this.organizations.some(o => o.name === this.form.name);
    },
    confirmOrganization() {
      this.$refs["confirm-organization-modal"].show();
    },
    confirmOrganizationSubmit() {
      this.submit(true);
    },
    confirmOrganizationCancel() {

    }
  },
  computed: {
    confirmMessage() {
      return `Use existing organization '${this.form.name}'?`;
    }
  }
}
</script>